import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import About from "../pages/about/page";
import Certificates from "../pages/certificates/page";
import Gallery from "../pages/gallery/page";
import BulkSupply from "../pages/bulk-supply/page";
import Contact from "../pages/contact/page";
import Mangoes from "../pages/mangoes/page";
import MangoDetail from "../pages/mangoes/detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/mangoes",
    element: <Mangoes />,
  },
  {
    path: "/mangoes/:variety",
    element: <MangoDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/certificates",
    element: <Certificates />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/bulk-supply",
    element: <BulkSupply />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
